<template>
  <div>
    <form class="plan col mt-lg-0">
      <div class="mb-5">
        <step-title
          title="Cadastrar Plano"
          description="Cadastre pelo menos um plano para completar o cadastro da sua assinatura. Você pode cadastrar quantas planos desejar a qualquer momento no
          gerenciamento do produto."
        />
      </div>

      <bp-input
        v-model="form.name"
        class="mt-5"
        id="name"
        label="Nome do plano"
        placeholder="Este nome será exibido para os compradores. Ex: Plano Mensal"
        :errors="errors.name"
        description="Este nome será exibido apenas para você, em sua tabela de preços."
        required
      />

      <bp-input
        v-model="form.description"
        class="mt-5"
        id="description"
        label="Descrição no Checkout"
        placeholder="Insira uma descrição para sua página de pagamentos"
        textarea
        :errors="errors.description"
        description="Atenção! Esta descrição aparecerá para seus compradores."
        rows="5"
        :limit="980"
        required
      />

      <hr class="mt-6" />

      <h3 class="mt-6">Precificação do plano</h3>

      <bp-input
        v-model="form.price"
        money
        :moneyConfig="moneyConfig"
        class="my-5"
        id="price"
        preIcon="fa-light fa-brazilian-real-sign"
        label="Valor em Real Brasileiro (R$)"
        placeholder="Informe o preço"
        :errors="errors.price"
        required
        description="Defina quanto custará o seu produto. Certifique-se de que o valor não seja menor que R$ 4,00."
        :min="4"
      />
      <bp-input
        :disabled="!showForeign"
        :info="getInfo('USD')"
        v-model="form.price_usd"
        money
        :moneyConfig="{ ...moneyConfig, currency: '$' }"
        class="my-5"
        id="price"
        preIcon="fa-light fa-dollar"
        label="Valor em Dólar Americano (US$)"
        placeholder="Informe o preço"
        :errors="errors.price_usd"
        description="Defina quanto custará o seu produto. Certifique-se de que o valor não seja menor que US$ 4,00."
        :min="4"
      />
      <bp-input
        :disabled="!showForeign"
        :info="getInfo('EUR')"
        v-model="form.price_eur"
        money
        :moneyConfig="{ ...moneyConfig, currency: '€' }"
        class="my-5"
        id="price"
        preIcon="fa-light fa-euro"
        label="Valor em Euro (€)"
        placeholder="Informe o preço"
        :errors="errors.price_eur"
        description="Defina quanto custará o seu produto. Certifique-se de que o valor não seja menor que € 4,00."
        :min="4"
      />

      <bp-select
        v-model="form.periodicity"
        :disabled="!!form.id"
        select
        id="frequency"
        label="Periodicidade"
        placeholder="Selecionar..."
        :options="frequencyOptions"
        :errors="errors.periodicity"
        description="Escolha quando deverá ocorrer a renovação da assinatura."
        required
      />

      <bp-input
        v-if="showTestDays"
        class="mt-5"
        v-model="form.test_days"
        id="test_days"
        label="Dias de teste grátis"
        placeholder="0"
        :errors="errors.test_days"
        mask="###"
        :description="
          'Defina quantos dias de teste grátis o cliente terá antes da primeira cobrança. \n Transações de período de teste terão cobrança automática de R$ 1,00. Caso esteja tudo certo com a transação, o estorno é feito automaticamente, mantendo o período de teste estipulado.'
        "
      />

      <action-dispatcher
        action="sale/getInstallments"
        :key="`${frequencyMonths}${form.price}`"
        :parameters="
          clearObject({
            product_id: $route.params.id,
            installments: frequencyMonths,
            value: form.price
          })
        "
        v-if="form.price && frequencyMonths"
      >
        <bp-select
          v-model="form.installments"
          class="mt-6"
          id="installment"
          label="Parcelamento"
          placeholder="Selecionar..."
          :options="installmentOptions"
          :errors="errors.installments"
          description="Para parcelar, a periodicidade da assinatura deve ser pelo menos
          bimestral."
        />
      </action-dispatcher>

      <b-form-checkbox v-model="promotionalPrice" switch class="mt-6">
        Novo preço depois do primeiro pagamento
      </b-form-checkbox>

      <div v-if="promotionalPrice">
        <bp-input
          v-model="form.next_cycle_price"
          class="mt-5"
          money
          id="price"
          label="Novo preço"
          placeholder="Informe o preço"
          :errors="errors.next_cycle_price"
          required
          description="Defina qual será o novo valor a ser cobrado no seu plano,
          certificando-se que não seja um valor menor que R$4,00."
          :min="4"
        />
      </div>

      <bp-radio
        v-model="form.billing"
        class="mt-6"
        id="billing"
        label="Forma de cobrança"
        :options="billingOptions"
        :errors="errors.billing"
        required
        vertical
      />

      <bp-input
        v-if="form.billing === 2"
        v-model="form.num_max_payments"
        class="mt-5"
        id="num_max_payments"
        label="Número máximo de recorrências"
        number
        placeholder="0"
        :errors="errors.num_max_payments"
        required
        :min="1"
      />

      <bp-input
        v-model="form.sck"
        class="mt-3"
        id="sck"
        label="SCK"
        placeholder="Digite o parâmetro desejado"
        description="Esse parâmetro te ajudará a identificar a origem da compra."
      />
      <div class="pt-6">
        <bp-button
          :disabled="!isValid"
          @click="savePlan"
          label="Salvar plano"
        />
        <!-- <button
          class="btn btn-sm px-6 py-3"
          :class="isValid ? 'btn-primary ' : 'btn-secondary'"
          :disabled="!isValid"
          @click="savePlan"
        >
          Salvar plano
        </button> -->
      </div>

      <div v-if="plans && plans.length">
        <hr />
        <offers-or-plans-container
          :items="plans"
          @delete="onRemove"
          @edit="onEdit"
        />
      </div>
    </form>
  </div>
</template>

<script>
import OffersOrPlansContainer from "@/components/product/OffersOrPlansContainer";
import { ABREVIATION_TO_SYMBOL_MAP } from "@/constants/sales.js";
import { formFields } from "@/functions/helpers.js";
import { mapState } from "vuex";
import { clearObject } from "../../functions/helpers";
const fields = [
  "id",
  "name",
  "description",
  "price",
  "price_usd",
  "price_eur",
  "periodicity",
  "installments",
  "next_cycle_price",
  "testing",
  "test_days",
  "billing",
  "num_max_payments",
  "payment_form",
  "status",
  "sck"
];
export default {
  components: {
    OffersOrPlansContainer
  },
  props: {
    plans: {
      type: Array,
      default: () => []
    },
    productCurrency: {
      type: String,
      default: ""
    },
    planToEdit: {
      type: Number,
      default: null
    },
    product_id: {
      type: Number,
      default: null
    },
    showLoading: {
      type: Boolean,
      default: false
    },
    paymentMethods: {
      type: Array,
      default: () => []
    }
  },
  data() {
    let plan = {
      status: "active",
      installments: 1
    };

    if (Number.isInteger(this.planToEdit)) {
      plan = {
        ...plan,
        ...this.plans[this.planToEdit]
      };
      plan.testing = this.plans[this.planToEdit]?.test_days || 0;
      plan.price = Number(this.plans[this.planToEdit].price);
      plan.billing = this.plans[this.planToEdit].num_max_payments === 0 ? 1 : 2;
    }

    return {
      ...formFields(fields, plan),
      promotionalPrice: false,
      modalDeleteVisible: false,
      indexToEdit: null,
      billingOptions: [
        { id: 1, name: "Até o cliente cancelar" },
        { id: 2, name: "Definir um número máximo" }
      ],
      moneyConfig: {
        decimal: ",",
        thousands: ".",
        precision: 2,
        prefix: "",
        masked: false
      }
    };
  },
  watch: {
    promotionalPrice(v) {
      if (!v) this.form.next_cycle_price = "";
    },
    "form.billing"(v) {
      if (v === 1) {
        this.form.num_max_payments = 0;
      }
    },
    planToEdit(v) {
      if (Number.isInteger(v)) {
        this.form = {
          ...this.plans[v],
          testing: this.plans[v]?.test_days || 0,
          price: Number(this.plans[v].price),
          billing: this.plans[v].num_max_payments ? 2 : 1,
          test_days: Number(this.plans[v]?.test_days)
        };
      }
    }
  },
  computed: {
    ...mapState("product", ["warranties", "currencies", "frequencyOptions"]),
    ...mapState("sale", ["installments"]),
    canChangeInstallment() {
      return (
        this.form.periodicity === "monthly" ||
        this.form.periodicity === "weekly" ||
        !this.form.price
      );
    },
    paymentFormOptions() {
      return [
        { id: 1, name: "Pagamento à vista" },
        { id: 2, name: "Pagamento sem tarifas para o cliente" },
        { id: 3, name: "Pagamento com tarifas para o cliente" }
      ];
    },
    moneyPrefix() {
      return ABREVIATION_TO_SYMBOL_MAP[this.productCurrency];
    },
    isValid() {
      return (
        this.form.price &&
        this.form.price >= 4 &&
        (!parseFloat(this.form.price_eur) || this.form.price_eur >= 4) &&
        (!parseFloat(this.form.price_usd) || this.form.price_usd >= 4) &&
        this.form.description &&
        this.form.description.length <= 980 &&
        this.form.name &&
        (this.form.next_cycle_price >= 4 || !this.promotionalPrice) &&
        this.form.periodicity &&
        this.form.billing &&
        (this.form.billing === 1 || Number(this.form.num_max_payments))
      );
    },
    frequencyMonths() {
      if (!this.form.periodicity) {
        return 0;
      }
      if (["weekly", "monthly"].includes(this.form.periodicity)) {
        return 1;
      }
      return this.frequencyOptions.find(
        item => item.id === this.form.periodicity
      ).months;
    },
    installmentOptions() {
      const opts = [];
      for (let id in this.installments) {
        opts.push({
          id: parseInt(id),
          name: `Até ${id} parcela${id - 1 ? "s" : ""} de R$ ${
            this.installments[id]
          }`
        });
      }
      return opts;
    },
    showTestDays() {
      const allowedMethods = [1, 2, 4];
      return this.paymentMethods.some(method =>
        allowedMethods.includes(method)
      );
    },
    showForeign() {
      return this.paymentMethods.includes(1);
    }
  },
  methods: {
    getInfo(currency) {
      if (this.showForeign) return "";
      const currencyName = {
        USD: "dólar americano",
        EUR: "euro"
      };
      return `Para habilitar configuração de preço em ${currencyName[currency]} seu checkout precisa aceitar Cartão de Crédito.`;
    },
    clearObject(v) {
      return clearObject(v);
    },
    changeTestingPeriod() {
      this.form.testing = !this.form.testing;
    },
    onEdit(index) {
      this.$emit("edit", index);
    },
    onRemove(index) {
      this.$emit("delete", index);
    },
    toggleModal() {
      this.modalDeleteVisible = !this.modalDeleteVisible;
    },
    clear() {
      const { form, errors } = formFields(fields, {});
      this.form = form;
      this.errors = errors;
      this.indexToEdit = null;
    },
    savePlan() {
      if (this.planToEdit === null) {
        const existPlan = this.plans.find(p => p.name == this.form.name);
        if (existPlan) {
          this.errors.name = ["Já existe um plano com esse nome"];
          window.scrollTo(0, 0);
          return;
        }
        if (this.form.price < 4) {
          this.errors.price = ["O valor não pode ser menor que R$ 4,00"];
          return;
        }
      }
      this.$emit("savePlan", this.form); // When plan is in Editing
      this.clear();
    }
  }
};
</script>

<style lang="scss" scoped>
.plan {
  .icon-angle-right,
  .icon-angle-left {
    font-size: 24px;
    margin-bottom: 3px;
  }
  .container-back {
    i {
      font-size: 24px;
      margin-right: 8px;
      cursor: pointer;
    }
  }
  .checkbox-tests {
    cursor: pointer;

    i {
      font-size: 24px;
      margin-right: 8px;
    }
  }
}
</style>
